import Selector from '../../../../../components/selector';
import {Button, Form, Icon} from 'antd';
import React, {useState} from 'react';
import {MODAL_WIDTH_LG, MODAL_WIDTH_SM} from '../../../../../styles/constants';
import {translate} from 'react-i18next';
import Call from '../../../../../hocs/call';
import FileMappingForm from '../../../../../components/file-mapping-form';
import {
  hideLoaderCsvFormMappingControlDetailMapping,
  hideLoaderCsvFormMappingControlMappings,
  hideLoaderCsvFormMappingControlSelectedMapping,
  readLoaderCsvFormMappingControlDetailMapping,
  readLoaderCsvFormMappingControlDetailMappingCube,
  readLoaderCsvFormMappingControlMappings,
  readLoaderCsvFormMappingControlSelectedMapping,
  readLoaderCsvFormMappingControlSelectedMappingCube,
  setLoaderCsvFormMappingControlMapping,
  showLoaderCsvFormMappingControlDetailMapping,
  showLoaderCsvFormMappingControlMappings,
  showLoaderCsvFormMappingControlSelectedMapping,
  unsetLoaderCsvFormMappingControlMapping
} from './actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
import EnhancedModal from '../../../../../components/enhanced-modal';
import EnhancedTree from "../../../../../components/enhanced-tree";
import {getNodes} from "../../../../../utils/tree";
import {getLocalizedStr} from "../../../../../middlewares/i18n/utils";
import {BUTTON_DETAIL} from "../../../../../styles/buttons";

const IconFontCNIcon = Icon.createFromIconfontCN({
  scriptUrl: './static/vendor/iconfont_cn/iconfont.js',
});

const mapStateToProps = state => ({
  selectedMappingId: state.scenes.dataManager.loader.components.csvForm.shared.mappingId,
  selectedMapping: state.scenes.dataManager.loader.components.csvForm.shared.mapping,
  selectedMappingCube: state.scenes.dataManager.loader.components.csvForm.shared.mappingCube,
  isSelectedMappingVisible: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.isSelectedMappingVisible,
  isMappingsVisible: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.isMappingsVisible,
  mappingsTree: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.mappingsTree,
  detailMappingId: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailMappingId,
  detailMapping: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailMapping,
  detailMappingCube: state.scenes.dataManager.loader.components.csvForm.components.mappingControl.detailMappingCube,
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages
});

const mapDispatchToProps = dispatch => ({
  onMappingSet: mappingId => dispatch(setLoaderCsvFormMappingControlMapping(mappingId)),
  onMappingUnset: () => dispatch(unsetLoaderCsvFormMappingControlMapping()),
  onMappingsShow: () => dispatch(showLoaderCsvFormMappingControlMappings()),
  onDetailMappingShow: mappingId => dispatch(showLoaderCsvFormMappingControlDetailMapping(mappingId)),
  onSelectedMappingShow: () => dispatch(showLoaderCsvFormMappingControlSelectedMapping()),
  onMappingsHide: () => dispatch(hideLoaderCsvFormMappingControlMappings()),
  onDetailMappingHide: () => dispatch(hideLoaderCsvFormMappingControlDetailMapping()),
  onSelectedMappingHide: () => dispatch(hideLoaderCsvFormMappingControlSelectedMapping()),
  fetchMappings: () => dispatch(readLoaderCsvFormMappingControlMappings()),
  fetchDetailMapping: mappingId => dispatch(readLoaderCsvFormMappingControlDetailMapping(mappingId)),
  fetchDetailMappingCube: cubeId => dispatch(readLoaderCsvFormMappingControlDetailMappingCube(cubeId)),
  fetchSelectedMapping: mappingId => dispatch(readLoaderCsvFormMappingControlSelectedMapping(mappingId)),
  fetchSelectedMappingCube: cubeId => dispatch(readLoaderCsvFormMappingControlSelectedMappingCube(cubeId))
});

const LoaderCsvFormMappingControl = ({
                                       t,
                                       form,
                                       appLanguage,
                                       dataLanguages,
                                       selectedMappingId,
                                       selectedMapping,
                                       selectedMappingCube,
                                       isSelectedMappingVisible,
                                       isMappingsVisible,
                                       mappingsTree,
                                       detailMappingId,
                                       detailMapping,
                                       detailMappingCube,
                                       onMappingSet,
                                       onMappingUnset,
                                       onMappingsShow,
                                       onDetailMappingShow,
                                       onSelectedMappingShow,
                                       onMappingsHide,
                                       onDetailMappingHide,
                                       onSelectedMappingHide,
                                       fetchMappings,
                                       fetchDetailMapping,
                                       fetchDetailMappingCube,
                                       fetchSelectedMapping,
                                       fetchSelectedMappingCube
                                     }) => {

  const [selected, setSelected] = useState(null);

  return (
    <Call cb={fetchSelectedMapping} cbParam={selectedMappingId}
          disabled={selectedMappingId === null}>
      <Call
        cb={fetchSelectedMappingCube}
        cbParam={selectedMapping !== null && selectedMapping.IDCube}
        disabled={selectedMapping === null}
      >
        <EnhancedModal
          visible={isSelectedMappingVisible}
          onCancel={onSelectedMappingHide}
          title={t('scenes.dataManager.loader.csvForm.mappingControl.selectedMapping.title')}
          width={MODAL_WIDTH_SM}
          footer={<Button
            onClick={onSelectedMappingHide}>{t('commons.buttons.close.title')}</Button>}
        >
          <FileMappingForm fileMapping={selectedMapping} cube={selectedMappingCube}/>
        </EnhancedModal>
        <EnhancedModal
          visible={isMappingsVisible}
          onCancel={onMappingsHide}
          title={t('scenes.dataManager.loader.csvForm.mappingControl.mappingList.title')}
          width={MODAL_WIDTH_LG}
          footer={
            <div>
              <Button onClick={onMappingsHide}>
                {t('commons.buttons.close.title')}
              </Button>
              <Button
                onClick={() => onMappingSet(selected)}
                type="primary"
                disabled={!selected}
              >
                {t('commons.buttons.select.title')}
              </Button>
            </div>
          }
        >
          <Call cb={fetchMappings}>
            <div className="loader__csv-form__tree">
              <EnhancedTree
                tree={mappingsTree}
                idKey="TreeID"
                nameKey="Name"
                childrenKey="children"
                catIdKey="TreeID"
                catNameKey="labels"
                getIsNameMultilanguage={node => !node.IDMapping}
                unselectableKeys={
                  getNodes(mappingsTree, 'children', node => !node.IDMapping)
                    .map(node => node.TreeID)
                }
                hiddenIdKeys={
                  getNodes(mappingsTree, 'children', (({Code}) => !Code))
                    .map(node => node.TreeID)
                }
                getIcon={({Code, IDMapping}) => {
                  if (Code) {
                    return (
                      <IconFontCNIcon
                        theme="filled"
                        style={{color: "#37a0f4"}}
                        type="cube"
                      />
                    );
                  } else if (IDMapping) {
                    return (
                      <Icon
                        theme="filled"
                        type="file-text"
                      />
                    );
                  } else {
                    return null;
                  }
                }}
                getFilter={
                  searchText =>
                    ({labels, Code, Name}) => {
                      const search = searchText.toLowerCase();
                      return (Name && Name.toLowerCase()
                          .indexOf(search) >= 0) ||
                        (Code && Code.toLowerCase()
                          .indexOf(search) >= 0) ||
                        (labels && getLocalizedStr(labels, appLanguage, dataLanguages)
                          .toLowerCase()
                          .indexOf(search) >= 0);
                    }
                }
                onSelect={selectedArr => {
                  if (selectedArr && selectedArr[0]) {
                    setSelected(Number(selectedArr[0].replace("Mapp_", "")))
                  } else {
                    setSelected(null);
                  }
                }}
                treeActions={[
                  {
                    title: t('scenes.dataManager.loader.csvForm.mappingControl.refreshTree.title'),
                    icon: 'sync',
                    onClick: fetchMappings
                  }
                ]}
                actions={[
                  selected
                    ? {
                      ...BUTTON_DETAIL,
                      title: t('components.itemList.actions.view.title'),
                      onClick: () => onDetailMappingShow(selected)
                    }
                    : null
                ]}
              />
            </div>
          </Call>
        </EnhancedModal>
        <EnhancedModal
          visible={detailMappingId !== null}
          onCancel={onDetailMappingHide}
          title={t('scenes.dataManager.loader.csvForm.mappingControl.detailMapping.title')}
          width={MODAL_WIDTH_SM}
          footer={<Button onClick={onDetailMappingHide}>{t('commons.buttons.close.title')}</Button>}
        >
          <Call cb={fetchDetailMapping} cbParam={detailMappingId}>
            <Call
              cb={fetchDetailMappingCube}
              cbParam={detailMapping !== null && detailMapping.IDCube}
              disabled={detailMapping === null}
            >
              <FileMappingForm fileMapping={detailMapping} cube={detailMappingCube}/>
            </Call>
          </Call>
        </EnhancedModal>
        <Form.Item>
          {form.getFieldDecorator('mappingId')(
            <Selector
              detailTitle={t('scenes.dataManager.loader.csvForm.mappingControl.detailIcon.title')}
              selectTitle={t('scenes.dataManager.loader.csvForm.mappingControl.selectIcon.title')}
              resetTitle={t('scenes.dataManager.loader.csvForm.mappingControl.resetIcon.title')}
              onDetail={onSelectedMappingShow}
              onSelect={onMappingsShow}
              onReset={onMappingUnset}
            />
          )}
        </Form.Item>
      </Call>
    </Call>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(LoaderCsvFormMappingControl);



// WEBPACK FOOTER //
// ./src/scenes/data-manager/loader/csv-form/mapping-control/index.jsx